<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__scopecity">
      <div class="leftNav" >
       <!-- <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>  -->
        <!-- <el-tree
     
         :data="getPageList"
         :props="defaultProps"
          @node-click="handleNodeClick"
          class="filter-tree"
          :filter-node-method="filterNode"
          ref="tree"
          ></el-tree> -->
          <el-tree
          :props="props"
          :load="loadNode"
          lazy
          :highlight-current="true"
          @node-click="handleNodeClick"
          >
        </el-tree>
 
      </div>
      <div class="rightTable">
        <!-- <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-button v-if="$hasPermission('sys:scopecity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
        </el-form> -->
        
        <city-management ref="management"></city-management>
      </div>
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './scopecity-add-or-update'
import { addDynamicRoute } from '@/router'
import CityManagement from '@/components/cityManagement.vue'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/scopecity/page',
        getDataListIsPage: true,
        exportURL: '/sys/scopecity/export',
        deleteURL: '/sys/scopecity',
        deleteIsBatch: true
      },
      props: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
      filterText: '',
      citys:[],
      pages:[],
      loanList: [],
      isFixed: [
        {
          name: '非直投',
          id: 0,
        },
        {
          name: '直投',
          id: 1,
        },
      ],
      pageList: [{
          label: '落地页1',
          children: [
            {
             label: '上海',
           },
           {
             label: '北京',
           },
         ]
        }],

        defaultProps: {
          children: 'children',
          label: 'label',
          
        },

      strategys:[
        // {
        //   'label':'顺序',
        //   'value':1,
        // },
        {
          'label':'轮询',
          'value':1,
        },
        {
          'label':'随机',
          'value':2,
        }
      ],
      dataForm: {
        pageId: '',
        city: '',
        strategy:''
      }
    }
  },
  components: {
    AddOrUpdate,
    CityManagement
  },
  created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query()
      this.getPageOptions();
    }
  },
 
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  methods: {
    handleNodeClick(data) {
        // console.log(data)
        if(data.id == 0 || data.id == 1){
          this.$refs.management.init(false,3)
        }
        if(data.scopeCityId){
          console.log(data.node.data.id)
          this.$refs.management.init(data.scopeCityId,1,data.node.data.id)
          return
        }else if(data.pageId){
          console.log(data.node.data)
          this.$refs.management.init(data.pageId,2 ,data.node.data.id)
          return
        }
        
      },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
    async loadNode(node, resolve) {
      // console.log(node,'node')
       if(node.level === 0){
        return  resolve(this.isFixed);
       }
       if (node.level === 1) {
       let result = await this.getLoantypeOptions()
       return  resolve(result.data.data.map(item => ({name: item.dictLabel})));
       }
       if (node.level === 2) {
        // if(node.parent.data.id)
       this.$http.get(`/sys/landingPageCity/landingpages/page?limit=3000&isFixed=${node.parent.data.id}&loanType=${node.data.name}`).then(({data: res})=> {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
         
          let data = res.data.list.map(item => ({name: item.name, pageId: item.id ,node: node.parent}))
          resolve(data);
        })
       }
       if(node.level === 3){
        this.$http.get(`/sys/landingPageCity/scopecity/page?limit=3000&pageId=${node.data.pageId}`).then(({data: res})=> {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
       
          let data = res.data.list.map(item => ({name: item.city, scopeCityId: item.id ,node: node.parent.parent}))
          resolve(data);
        })
       }
     
       if(node.level === 4){
        resolve([]);
        // this.$http.get(`/sys/scopecitycompany/page?pageId=${node.data.scopeCityId}`).then(({data: res})=> {
        //   if (res.code !== 0) {
        //     return this.$message.error(res.msg)
        //   }
        //  console.log(res)
        // })
       }
      
       
     

       
    },
    
    // 回调函数 返回树形数据
    getArr(event){
      return [{
          label: event.pageName,
          children: [
            ...event.city.split(',').map(item => ({ label: item }))
         ]
        }]
    },
    // handleNodeClick(data) {
    //     console.log(data);
    //     this.childHandle(data)
    //   },
    
     //初始化下拉框中的选项
     async getLoantypeOptions() {
      let res = await  this.$http.get(`/sys/dict/data/list?dataType=loan_type`)
      return res
      // .then(({ data: res }) => {
      //   if (res.code !== 0) {
      //     return this.$message.error(res.msg)
      //   }
      //   this.loanList=[];
      //   if (res.data!=null){
      //     res.data.forEach(element => {
      //       this.loanList.push({label:element.dictLabel,value:element.dictValue})
      //     })
      //   }
      
      // }).catch(() => {})
      
    },
   
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
       
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pages=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.pages.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    },
    // 子级
    childHandle (row) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__${row.id}`,
        title: `${this.$route.meta.title} - ${row.pageName} - ${row.city}`,
        path: 'sys/scopecitycompany',
        params: {
          scopeCityId: row.id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>
<style scoped lang="scss">
.mod-demo__scopecity{
  height: 100%;
  display: flex;
  .leftNav{
    height: calc(calc(100vh - 50px - 38px - 100px) - 2px);
    // min-height: 400px;
    width: 300px;
    overflow-y: auto;
    margin-right: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
    border-radius: 10px; /* 添加圆角 */
    padding: 20px; /* 添加内边距 */
  }
  .rightTable{
    flex: 1;
  }
}
  ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background: #409eff;
        color: #fff;
  } 

</style>
